import { TransactionCategoryEnum, TransactionTypeEnum } from '@/enums';
import { ControlledSelect } from '@/components/controlled';
import { useFormContext, useWatch } from 'react-hook-form';
import { getSelectOptions, nameof } from '@/functions';
import { LabelRequired } from '@/components/hoc';
import { useEffect } from 'react';
import type { TFormData } from '..';

const FormCreateOrEditTransactionBodyInputCategory = () => {

  const { control, setValue, trigger, getValues } = useFormContext<TFormData>();
  const category = useWatch({ control, name: 'category' });

  const allOptions = getSelectOptions('TransactionCategoryEnum');

  useEffect(() => {
    if (!category) return;

    const incomeCategories = [TransactionCategoryEnum.IN_APP_PURCHASE, TransactionCategoryEnum.OTHER_INCOME];

    if (incomeCategories.includes(category as TransactionCategoryEnum)) {
      setValue('type', TransactionTypeEnum.INCOME);
    } else {
      setValue('type', TransactionTypeEnum.EXPENSE);
    }

    /* the allowed dates depend on the category: check again a date already picked */
    if (getValues('occurredAt')) trigger('occurredAt');
  }, [category, setValue, trigger, getValues]);

  return (
    <div className='flex flex-col gap-1.5 flex-1 min-w-0'>
      <LabelRequired className="text-[11px] md:text-xs">
        Catégorie
      </LabelRequired>
      <ControlledSelect
        control={control}
        rules={{ required: 'Requis' }}
        name={nameof<TFormData>('category')}
        placeholder='Sélectionner...'
        options={allOptions} />
    </div>
  );

};

export default FormCreateOrEditTransactionBodyInputCategory;
